import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { Account } from "@rentablo/api/apiv1";
import { useGetBankConnection } from "@rentablo/api/apiv3";
import { Banner } from "@rentablo/components";

interface Props {
  account?: Account;
}

// v1 and v2 share a BIC; only the wealthAPI bank slug tells them apart.
export const BitpandaV1Banner = ({ account }: Props) => {
  const { t } = useTranslation();
  const bankConnectionId = account?.bankConnectionId;
  const { data: bankConnection } = useGetBankConnection(
    { id: bankConnectionId! },
    {
      enabled:
        account?.bankConnectionType === "WEALTH_API" &&
        account.bicGroup === "LHVBEE22XXX" &&
        bankConnectionId != null,
    }
  );

  if (bankConnection?.data.attributes.bank_name !== "Bitpanda") return null;

  return (
    <Box px={6}>
      <Banner
        displayDefaultIcon
        type="warn"
        text={t("bitpandaV1Banner")}
        mb={4}
      />
    </Box>
  );
};
